import { useAuth } from "../../../../context/AuthContext";
import Projects from "../list/Projects";
import AmsProjects from "../../../amsProject/pages/list/AmsProjects";

export default function ProjectListRouter() {
    const { activeDepartment } = useAuth();

    if (activeDepartment === 'AMS') {
        return <AmsProjects />;
    }

    return <Projects />;
}
